import React, {FC} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import styles from './ProductPaginationControls.module.css'

interface ProductPaginationControlsProps {
  currentPage: number
  totalPages: number
  itemsPerPage: number
  totalItems: number
  onPageChange: (page: number) => void
  onItemsPerPageChange: (items: number) => void
  onLoadMore?: () => void
  showLoadMoreButton?: boolean
}

/**
 * Componente de controles de paginação para o card de produtos
 * Oferece navegação tradicional (Anterior/Próximo) e opção "Carregar Mais"
 */
export const ProductPaginationControls: FC<ProductPaginationControlsProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  onLoadMore,
  showLoadMoreButton = false,
}) => {
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  const handlePrev = () => {
    if (!isFirstPage) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (!isLastPage) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div className={`d-flex justify-content-between align-items-center mb-4 ${styles.paginationContainer}`}>
      {/* Navegação esquerda: Anterior/Próximo */}
      <div className={`d-flex align-items-center gap-3 ${styles.navButtons}`}>
        <button
          className={`btn btn-sm btn-light-primary ${isFirstPage ? 'disabled' : ''}`}
          onClick={handlePrev}
          disabled={isFirstPage}
          title='Página anterior'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-2' />
          <span className='ms-2'>Anterior</span>
        </button>

        <div className={styles.pageIndicator}>
          <span>
            Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
          </span>
        </div>

        <button
          className={`btn btn-sm btn-light-primary ${isLastPage ? 'disabled' : ''}`}
          onClick={handleNext}
          disabled={isLastPage}
          title='Próxima página'
        >
          <span className='me-2'>Próximo</span>
          <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
        </button>
      </div>

      {/* Navegação direita: Seletor de itens + Total */}
      <div className={`d-flex align-items-center gap-2 ${styles.rightControls}`}>
        <label htmlFor='itemsPerPageSelect' className={styles.label}>
          Itens por página:
        </label>
        <select
          id='itemsPerPageSelect'
          className={`form-select form-select-sm ${styles.select}`}
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          title='Selecione quantos produtos exibir por página'
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>

        <span className={styles.totalBadge}>
          Total: <strong>{totalItems}</strong> produtos
        </span>

        {/* Botão Carregar Mais (opcional) */}
        {showLoadMoreButton && !isLastPage && (
          <button
            className='btn btn-sm btn-light-info ms-3'
            onClick={onLoadMore}
            title='Clique para adicionar mais produtos à visualização'
          >
            <span>Carregar Mais</span>
          </button>
        )}
      </div>
    </div>
  )
}
